import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchMonthlyReportInCurrentBoard(year, month, listId) {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  const y = Number(year);
  const m = Number(month);

  yield put(actions.fetchMonthlyReport(pointSystem.id, y, m));

  let item;
  try {
    ({ item } = yield call(request, api.getMonthlyReport, pointSystem.id, { year: y, month: m, listId }));
  } catch (error) {
    yield put(actions.fetchMonthlyReport.failure(error));
    return;
  }

  yield put(actions.fetchMonthlyReport.success(item));
}

export default {
  fetchMonthlyReportInCurrentBoard,
};

